var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{attrs:{"type":"plain","title":"Google Maps"}},[_c('div',{staticClass:"map",attrs:{"id":"map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }